import * as Types from '../actions/admin/ActionTypes';

const initialState = [];

const adminReducer = (state = initialState, action) => {
    const {type, payload} = action;

    switch (type) {
    case Types.GET_PRODUCTS_IN_STOCK:
        return payload;
    case Types.GET_MONTHLY_REPORT:
        console.log('Data -> GET_MONTHLY_REPORT', payload);
        return payload;
    case Types.GET_ALL_PRODUCTS_BY_CUSTOMER:
        return payload;
    case Types.GET_ALL_SUPPLIER_AND_PRODUCTS:
        return payload;
    case Types.CHECK_PRODUCT_IN_STOCK:
        return [payload];
    case Types.CHECK_STOCK:
        return [payload];
    case Types.CLEAR_STATE:
        return payload;
    default:
        return state;
    }
};

export default adminReducer;